import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapGetters('auth', 
    [
      'GET_QUERY',
      'GET_IS_QUERY',
      'GET_CLIENT',
      'GET_IS_CLIENT',
      'GET_IS_AUTHENTICATED',
      'GET_ACCESS_TOKEN',
      'GET_REFRESH_TOKEN',
      'GET_SECRET_KEY',
      'GET_OPEN_ID'
    ]),
}
export const authMethods = mapActions('auth', 
  [
    'ADD_QUERY', 
    'CLEAR_QUERY', 
    'ADD_CLIENT', 
    'CLEAR_CLIENT',
    'REMOVE_CLIENT',
    'REMOVE_EXPIRE_TOKEN',
    'SET_AUTHENTICATED_ALL',
    'REMOVE_ALL_AUTHENTICATED',
    'SET_IS_AUTHENTICATED',
    'SET_ACCESS_TOKEN',
    'SET_REFRESH_TOKEN',
    'SET_SECRET_KEY',
    'SET_QUERY_OBJ_SCOPES'
  ]
)

export const userComputed = {
  ...mapGetters('user', 
    [
      'GET_USER',
    ]),
}
export const userMethods = mapActions('user', ['ADD_USER', 'CLEAR_USER'])

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
}
export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])
